import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';
import View_Menu from 'page/account/menu';
import View_Api_Token_Row from 'view/api_token_row';

export default View.extend({
    tagName: 'section',

    events: {
        'click .create-token': 'createToken'
    },

    dom_handlers: {
        createToken: function(e) {
            e.preventDefault();
            Modals.createApiToken();
        }
    },

    views: {
        menu: {},
        api_tokens: {}
    },

    event_handlers: {
        onAdd: function(model) {
            this.views.api_tokens['_' + model.id] = new View_Api_Token_Row({model: model});
            this.views.api_tokens['_' + model.id].render().$el.insertAfter(this.$el.find('tr:first'));

            this.$el.find('.empty-notice').hide();
        },

        onRemove: function(model) {
            this.views.api_tokens['_' + model.id].remove();

            if (!Cache.api_token.length) {
                this.$el.find('.empty-notice').show();
            }
        }
    },

    initialize: function() {
        this.views.menu = new View_Menu();

        this.listenTo(Cache.api_token, 'add',    this.event_handlers.onAdd);
        this.listenTo(Cache.api_token, 'remove', this.event_handlers.onRemove);
    },

    onPageReady: function() {
        Cache.app.request({
            action: 'api_token/getData',
            context: this,
            success: function(response) {
                this.$el.find('.table-loader').remove();
                Cache.api_token.reset(response);

                Cache.api_token.each(function(model) {
                    this.views.api_tokens['_' + model.id] = new View_Api_Token_Row({model: model});
                    this.views.api_tokens['_' + model.id].render().$el.insertAfter(this.$el.find('table tr:last'));
                }, this);

                if (!Cache.api_token.length) {
                    this.$el.find('.empty-notice').show();
                }
            }
        });
    },

    render: function() {
        UI.setPageTitle('API Token');

        var content =
        '<main class="xlarge">' +
            '<div class="flex-between">' +
                '<div>Your API tokens need to be treated as securely as any other password. Maximum 20.</div>' +
                '<button class="create-token small primary float-right"><i class="far fa-plus margin-right-8"></i>Create API Token</button>' +
            '</div>' +
            '<div class="divider-24"></div>' +
            '<div>' +
                '<div class="box-medium">' +
                    '<div class="overflow-auto">' +
                        '<table cellpadding="0" cellspacing="0">' +
                            '<tr>' +
                                '<th>Label</th>' +
                                '<th>Last Accessed</th>' +
                                '<th>Created By</th>' +
                                '<th></th>' +
                            '</tr>' +
                        '</table>' +
                    '</div>' +
                    '<div class="empty-notice" style="display:none;">' +
                        '<div class="divider-large"></div>' +
                        '<p class="text-align-center font-weight-medium line-height-150">No API tokens found in your account.<br><a href="#" class="create-token primary">Create an API Token</a> and start using <a href="https://docs.userback.io/reference/overview" class="primary" rel="noopener" target="_blank">REST API <i class="fa-solid fa-square-arrow-up-right"></i></a>.</p>' +
                    '</div>' +
                    '<div class="table-loader loader loader-primary text-align-center" style="min-height:100px;"></div>' +
                '</div>' +
            '</div>' +
        '</main>';

        this.$el.html(content);

        this.views.menu.render().$el.prependTo(this.$el.find('main'));

        return this;
    }
});